// ** Third Party Components
import styled from "styled-components";

export const StyledMasonryCardWrapperNew = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	align-items: flex-start;
	justify-content: center;

	box-shadow: var(--dz-sys-card-shadow);
	border: 1px solid var(--dz-sys-card-shadow-border);
	border-radius: var(--dz-sys-card-border-radius);
	overflow: hidden;
	cursor: pointer;
	& * {
		cursor: pointer;
	}
	&:hover {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
	}
`;
